module.exports = __webpack_public_path__ + "media/images/top_menu_icon/machine_errors_index-2bd5bcc4d9b3a3ab20cee322e445cb4c.png";